import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { useGlobalStore } from '@/stores/global';
import { 
  Ship, 
  Settings, 
  BarChart3, 
  AlertTriangle, 
  Activity,
  Box,
  Menu,
  X
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const navigationItems = [
  {
    title: '3D数字孪生',
    href: '/3d-view',
    icon: Box,
  },
  {
    title: '系统总览',
    href: '/',
    icon: BarChart3,
  },
  {
    title: '发动机监控',
    href: '/engine-monitoring',
    icon: Activity,
  },
  {
    title: '告警系统',
    href: '/alerts',
    icon: AlertTriangle,
  },
  {
    title: '数据分析',
    href: '/analytics',
    icon: BarChart3,
  },
  {
    title: 'Three.js测试',
    href: '/three-test',
    icon: Box,
  },
  // {
  //   title: '系统设置',
  //   href: '/settings',
  //   icon: Settings,
  // },
];

export const Sidebar = () => {
  const { sidebarCollapsed, toggleSidebar } = useGlobalStore();
  const location = useLocation();

  return (
    <div className={cn(
      'tech-card rounded-none border-r border-primary/20 transition-all duration-300 flex flex-col relative overflow-hidden',
      sidebarCollapsed ? 'w-16' : 'w-64'
    )}>
      {/* 科技感背景装饰 */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-primary/5 opacity-30"></div>
      
      {/* Header */}
      <div className="p-4 border-b border-primary/20 relative z-10">
        <div className="flex items-center justify-between">
          {!sidebarCollapsed && (
            <div className="flex items-center space-x-2">
              {/* <Ship className="h-6 w-6 text-primary pulse-glow" /> */} 
              <img 
                src="/logo.png" 
                alt="Logo" 
                className="h-10 w-40 object-contain"
              />
              {/* <span className="font-bold text-lg bg-gradient-to-r from-primary to-cyan-400 bg-clip-text text-transparent">
                数字孪生平台
              </span> */}
            </div>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleSidebar}
            className="h-8 w-8 p-0 tech-button"
          >
            {sidebarCollapsed ? <Menu className="h-4 w-4" /> : <X className="h-4 w-4" />}
          </Button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 relative z-10">
        <ul className="space-y-2">
          {navigationItems.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <li key={item.href}>
                <Link to={item.href}>
                  <div className={cn(
                    'w-full relative rounded-lg transition-all duration-300 group',
                    isActive ? 'nav-item-active' : 'nav-item-normal'
                  )}>
                    {/* 活跃状态的左侧蓝色边框 */}
                    {isActive && (
                      <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-r-full shadow-[0_0_10px_rgba(0,153,255,0.6)]"></div>
                    )}
                    
                    <Button
                      variant="ghost"
                      className={cn(
                        'w-full justify-start border-0 bg-transparent relative z-10 h-12',
                        sidebarCollapsed && 'px-2',
                        isActive ? [
                          'bg-primary/15 border border-primary/40 text-primary font-medium',
                          'shadow-[0_0_15px_rgba(0,153,255,0.3)] backdrop-blur-sm',
                          'before:absolute before:inset-0 before:bg-gradient-to-r before:from-primary/10 before:to-transparent before:rounded-lg'
                        ] : [
                          'hover:bg-primary/10 hover:border-primary/30 text-muted-foreground',
                          'hover:text-foreground hover:shadow-[0_0_10px_rgba(0,153,255,0.2)]'
                        ]
                      )}
                    >
                      <item.icon className={cn(
                        "h-5 w-5 transition-colors duration-300", 
                        isActive ? "text-primary drop-shadow-[0_0_8px_rgba(0,153,255,0.6)]" : "text-muted-foreground group-hover:text-primary"
                      )} />
                      {!sidebarCollapsed && (
                        <span className={cn(
                          "ml-3 transition-colors duration-300", 
                          isActive ? "text-primary font-medium" : "text-muted-foreground group-hover:text-foreground"
                        )}>
                          {item.title}
                        </span>
                      )}
                      
                      {/* 悬浮时的发光效果 */}
                      {!isActive && (
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-r from-primary/5 to-transparent rounded-lg"></div>
                      )}
                    </Button>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
